import { GlobalVariable } from 'app/global/global';
import { CentroMedicoService } from 'app/services/centro-medico.service';
import { PacienteService } from 'app/services/paciente.service';
import { MatDialog } from '@angular/material/dialog';
import { ContactoDialogComponent } from 'app/shared/contacto-dialog/contacto-dialog.component';
import { Paciente } from 'app/models/paciente.interface';
import { environment } from 'environments/environment.prod';
import { ElementRef , Component , OnInit , ViewChild, Output ,Input, HostListener  } from '@angular/core';
import { Medico } from 'app/models/medico.interface';


@Component({
  selector: 'app-dashboard-paciente',
  templateUrl: './dashboard-paciente.component.html',
  styleUrls: ['./dashboard-paciente.component.scss']
})
export class DashboardPacienteComponent implements OnInit {
 
  
  //
  VERSION:string = GlobalVariable.VERSION_FRONT;
  titulo_contacto:string = 'Contacto';
  paciente:Paciente;
  centroMedico:any;
  imagen:string = "";
  turnoHabilitado:any;
  @ViewChild('dashboardContent') dashboardContent: ElementRef;
  @ViewChild('shadow') shadow: ElementRef;
  @Input() set menu(value:any){
    this.mostrarShadow(value);
  }
  @Input() set response(value:any){
    if(value){
      this.mostrarLogin(value);
    }
  }


  //
  constructor(
    public dialog:MatDialog,
    private apiPaciente:PacienteService,
    private centroService:CentroMedicoService
  ) {
    this.titulo_contacto = environment.BOTON_CONTACTO;
  }


  //
  mostrarLogin(data:any){
    this.paciente = data.paciente;
    this.centroMedico = data.centroMedico;
    this.imagen = `${GlobalVariable.BASE_API_URL}storage/images/centro-medico/${this.centroMedico.foto}`;
  }


  //
  ngOnInit(): void {
    this.turnoHabilitado = Number(localStorage.getItem('turno_habilitado'));
  }


  //
  mostrarShadow(value){
    if(value != undefined || value != null){
      this.shadow.nativeElement.style.display = "block";
      this.dashboardContent.nativeElement.style.left = "0px";
    }
  }


  //
  quitarShadow(){
    this.shadow.nativeElement.style.display = "none";
    this.dashboardContent.nativeElement.style.left = "-100%";
  }


  //
  contactoDialog(){
    let data = {
      usuario: this.paciente,
      tipoUsuario: 'paciente'
    }
    const dialogRef = this.dialog.open(ContactoDialogComponent,{
      panelClass: 'contacto-dialog',
      data: data
    })
    dialogRef.afterClosed().subscribe(res=>{})
  }


  //
  @HostListener('window:resize', ['$event']) onResize(event) {
    if(event.target.innerWidth > 900){
      this.dashboardContent.nativeElement.style.left = "0px";
      this.shadow.nativeElement.style.display = "none";
    }
    else if(event.target.innerWidth <= 900){
      this.dashboardContent.nativeElement.style.left = "-100%";
      this.shadow.nativeElement.style.display = "none";
    }
  }


}
